import { AxiosError } from "axios";
import Axios from "./axios";
import { ISignInDirect, DeviceType } from "./interfaces";

/*
Example:
  const api = new ApiModel();
  api.appToken = process.env.CERTIFY_API_ACCESS_KEY || process.env.NEXT_PUBLIC_CERTIFY_API_ACCESS_KEY;
*/

class ApiModel {
  handler: Axios;
  _accessToken: string | undefined;
  _refreshToken: string | undefined;

  /**
   * Creates an instance of Certify.
   * @example
   *   const api = new Certify();
   *   api.appToken = process.env.CERTIFY_API_ACCESS_KEY || process.env.NEXT_PUBLIC_CERTIFY_API_ACCESS_KEY;
   */
  constructor() {
    this.handler = Axios.getInstance();
  }

  /**
   * Sets api handler base url
   */
  set handlerBaseUrl(baseURL: string) {
    this.handler.setOptions({
      baseURL,
    });
  }

  get handlerBaseUrl(): any {
    return this.handler.getOptions();
  }

  set setAuthorizationToken(token: string | undefined) {
    if (token) {
      this._accessToken = token;
      this.handler.setAuthorizationToken(`Bearer ${token}`);
    }
  }

  set setAuthorizationRefreshToken(refreshToken: string | undefined) {
    if (refreshToken) {
      this._refreshToken = refreshToken;
      // this.handler.setAuthorizationToken(refreshToken);
    }
  }
}

export default ApiModel;
